import { makeStyles } from "@material-ui/core";
import { ManagerStatus } from "Shared/types/Admins";

type StyleProps = {
  status: string;
};

const useStyles = makeStyles(theme => ({
  text: {
    fontWeight: "inherit",
    color: "inherit",
  },
  title: {
    textTransform: "capitalize",
  },
  statusCell: {
    padding: theme.spacing(1, 5, 1, 2),
    fontWeight: 600,
  },
  status: {
    color: ({ status }: StyleProps) =>
      status.toLowerCase() === ManagerStatus["ACTIVE"]
        ? theme.palette.success.main
        : theme.palette.error.main,
  },
  longText: {
    wordBreak: "break-all",
  },
}));

export default useStyles;
